export const PLAY_SEARCH_ICON_PATHS = {
  back: "/icons/play/left.svg",
  search: "/icons/play/search.svg",
  close: "/icons/play/circle-x.svg",
};

export const PlaySearchOverlayIcon = ({ src, className = "" }) => (
  <span
    className={`block bg-current ${className}`}
    style={{
      WebkitMask: `url(${src}) center / contain no-repeat`,
      mask: `url(${src}) center / contain no-repeat`,
    }}
  />
);
